// extracted by mini-css-extract-plugin
module.exports = {"publish":"index--publish--2R9Ne"};